// Import and initialize medium-zoom
import mediumZoom from 'medium-zoom'
mediumZoom('[data-action="zoom"]')